export default {
  getProductImage: (state) => state.productImage,
};
